import styled from 'styled-components';

import { errorColor, primaryColor } from '~theme';

import activeSVG from '~images/radio_active.svg';
import inactiveSVG from '~images/radio_inactive.svg';

// TODO add support for info?
const RadioButtons = ({
  options,
  value,
  onChange,
  error,
  id,
  flat,
  firstElementMinWidth,
  // label
}) => (
  <Wrapper error={error} id={id} flat={flat}>
    {options?.map(option => (
      <OptionContainer
        key={option.value}
        firstElementMinWidth={firstElementMinWidth}
      >
        <Option id={option.id || ''} onClick={() => onChange(option.value)}>
          <RadioButton checked={value === option.value} />
          <Label>{option.label}</Label>
        </Option>
        {value === option.value && option.renderConditional && (
          <ChildContainer>{option.renderConditional()}</ChildContainer>
        )}
      </OptionContainer>
    ))}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${props => (props.flat ? 'row' : 'column')};
  justify-content: left;
  align-items: flex-start;
  margin-top: 4px;
  gap: 16px;

  // border: ${props => (props.error ? `1px solid ${errorColor}` : 'none')};
  border-radius: 6px;
`;

const OptionContainer = styled.div`
  ${props =>
    props.firstElementMinWidth && `min-width: ${props.firstElementMinWidth}`};
`;

const ChildContainer = styled.div`
  margin-left: 34px;
`;

const Option = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.label`
  font-size: 16px;
  margin-left: 12px;
  user-select: none;
  margin-bottom: 0;
  cursor: pointer;
  color: black;
  line-height: 1.5;
  // color: ${primaryColor};
`;

const RadioButton = ({ checked }) => (
  <Icon src={checked ? activeSVG : inactiveSVG} />
);

const Icon = styled.img`
  cursor: pointer;
`;

export default RadioButtons;
